import {
  FieldContextKey,
  useFieldError,
  useFieldValue,
  useIsFieldDirty,
  useIsFieldTouched,
  useIsFieldValid,
} from "vee-validate"
import { inject } from "vue"

import { FORM_ITEM_INJECTION_KEY } from "./FormItem.vue"

export function useFormField() {
  const fieldContext = inject(FieldContextKey)
  const fieldItemContext = inject(FORM_ITEM_INJECTION_KEY)

  const fieldState = {
    value: useFieldValue(),
    valid: useIsFieldValid(),
    isDirty: useIsFieldDirty(),
    isTouched: useIsFieldTouched(),
    error: useFieldError(),
  }

  if (!fieldContext)
    throw new Error("useFormField should be used within <FormField>")

  const { name, handleChange } = fieldContext
  const id = fieldItemContext

  return {
    id,
    name,
    handleChange,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState,
  }
}
